<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="800"
    @click:outside="closeButtonClickEvent"
  >
    <v-card>
      <v-card-title>テナント検索</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="searchForm.keyword"
              dense
              clearable
              label="キーワード"
              persistent-placeholder
              hide-details="auto"
            />
          </v-col>
          <v-col cols="2">
            <v-btn
              class="float-right"
              @click="searchButtonClickEvent"
            >
              検索
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          v-model="selected"
          :headers="tableHeaders"
          :items="tenants"
          show-select
          disable-sort
          hide-default-footer
        />
      </v-card-text>

      <v-divider />

      <!-- ページャ -->
      <v-row
        v-if="hasResult"
        dense
      >
        <v-col>
          <v-pagination
            v-model="page"
            :length="pagination.total_pages"
            :total-visible="totalVisible"
            circle
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="changePage"
          />
        </v-col>
      </v-row>
      <!-- /ページャ -->

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          color="info"
          @click="registerButtonClickEvent"
        >
          選択
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  name: 'TenantDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      selected: [],
      singleSelect: true,
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'name', text: '加入者名称' },
      ],
      searchForm: {
        keyword: null,
      },
      tenants: [],
    }
  },
  computed: {
    ...mapState('AdminTenant', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminTenant', [
      'hasResult'
    ]),
  },
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.requesterTenantFormValidator.reset())
      Object.assign(this.$data.searchForm, this.$options.data().searchForm);
      this.page = this.pagination.current_page
      this.searchTenant()

    },
    'searchForm.keyword': function (newVal) {
      this.saveCondition({ keyward: newVal })
    },
  },
  created() {
  },
  methods: {
    ...mapActions('AdminTenant', {
      fetchTenants: 'index',
    }),
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    registerButtonClickEvent () {
      this.$emit('registerEvent', this.selected)
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchTenant()
    },
    changePage () {
      this.searchTenant()
    },
    searchTenant () {
      let params = {
        keyward: this.searchForm.keyword,
        page: this.page
      }
      this.fetchTenants(params).then((content) => {
        this.tenants = content.tenants
      })
    }
  }
}
</script>

<style scoped>

</style>
